import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
import { BaseComponent } from "./BaseComponent";
export const dividerClasses = {
    root: "MinervaDivider-root",
};
export const dividerOrientationOptions = ["horizontal", "vertical"];
export const Divider = (props) => {
    const { orientation = "horizontal", color = 200, className, sx, ...rest } = useDefaultProps({ component: "Divider", props });
    return (_jsx(BaseComponent, { as: "hr", className: clsx([className, dividerClasses.root]), sx: mergeSx({
            backgroundColor: (theme) => theme.palette.stroke[color],
            height: orientation === "horizontal" ? 0.25 : "auto",
            alignSelf: "stretch",
            flexShrink: 0,
            width: orientation === "horizontal" ? "100%" : 0.25,
            marginBlockStart: 0,
            marginBlockEnd: 0,
            border: "none",
        }, sx), ...rest }));
};
//# sourceMappingURL=Divider.js.map